import { makeAutoObservable } from "mobx"
import { hasEmbeddedBrowser } from "../electronAPIs/browser"

export class EmbeddedBrowserAvailabilityStore {
    constructor(readonly bridgeAvailable: () => boolean = hasEmbeddedBrowser) {
        makeAutoObservable(this, { bridgeAvailable: false })
    }

    get available(): boolean {
        return this.bridgeAvailable()
    }
}

export const embeddedBrowserAvailabilityStore = new EmbeddedBrowserAvailabilityStore()
